<template>
  <div class="box">
    <navBar :tabIndex="99"></navBar>
    <img class="venue-topbg" src="@/assets/venue1.png" />
    <div class="search" style="position: relative">
      <input class="search-input" v-model="searchVal" @keyup.enter="onSearch" />
      <img
        @click="onClose"
        class="close-tip"
        src="@/assets/new/close.png"
        alt=""
      />
      <img
        @click="onSearch"
        class="search-tip"
        src="@/assets/new/searchBig.png"
        alt=""
      />
    </div>

    <div class="content">
      <div class="searchNum" style="text-align: left" v-if="isShow">
        搜索到“{{ oldSearchVal }}”相关纪念馆
        {{ totalLength ? totalLength : 0 }}个
      </div>
      <!-- 暂无内容 -->
      <div class="empty" v-if="list.length === 0">
        <img src="@/assets/new/empty.png" alt="" />
        <span>暂无内容</span>
      </div>

      <div
        class="data-list"
        v-for="(item, index) in list"
        :key="index"
        v-else
        :style="{
          'min-height':
            totalLength <= 2 && list.length === 1 ? '500px' : '280px',
        }"
      >
        <h1 class="list-title">{{ item.key }}</h1>
        <div class="val-list">
          <div
            class="main-list"
            v-for="(val, indexLabel) in item.value"
            @click.stop="toWorship(val)"
            :key="indexLabel"
          >
            <img
              class="img"
              :src="val.picture ? val.picture : val.spiritTabletUrl"
              alt=""
            />
            <div class="centItem">
              <div v-html="val.name" class="centname"></div>
              <div
                class="cent-flex"
                :style="{
                  'margin-bottom': $px2rem(`${11}px`),
                }"
              >
                <div class="message centtext">
                  建馆时间：<span class="day">{{
                    val.createTime.split(" ")[0]
                  }}</span>
                </div>
                <div class="message centtext">
                  香火值：<span>{{ val.actionStat.totalSpecialCount }}</span>
                </div>
              </div>
              <div class="cent-flex">
                <div class="message centtext">
                  留言数量：<span>{{ val.messageCount }}</span>
                </div>
                <div class="message centtext">
                  供品数量：<span>{{ val.giftCount }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="cent-ct">
              <div v-html="val.name" class="centname"></div>
              <div class="message" style="padding-top: 7px">
                建馆时间：<span class="day">{{
                  val.createTime.split(" ")[0]
                }}</span>
              </div>
              <div class="message" style="padding-top: 7px">
                留言数量：<span>{{ val.messageCount }}</span>
              </div>
            </div> -->
            <!-- <div class="rig-ct cent-ct">
              <div v-html="val.name" class="centname" style="opacity: 0"></div>
             <div class="message">
                香火值：<span>{{ val.actionStat.totalSpecialCount }}</span>
              </div>
              <div class="message" style="padding-top: 7px">
                供品数量：<span>{{ val.giftCount }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <tabBar></tabBar>
  </div>
</template>
<script>
import "./index.scss";
import { getSearch } from "@/api/request";
export default {
  data() {
    return {
      searchVal: "",
      list: [],
      totalLength: null,
      isShow: false,
      oldSearchVal: null,
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      // 监听路由参数值的变化

      // this.$route.query.redirect

      this.searchVal = to.query.val;
      this.onSearch();
    },
  },
  created() {
    this.searchVal = this.$route.query.val;
    this.onSearch();

    // if (this.$route.path === '/home') {
    //   console.log('You are on the home route');
    //   // 在这里执行与 home 路由相关的操作
    // } else if (this.$route.path === '/about') {
    //   console.log('You are on the about route');
    //   // 在这里执行与 about 路由相关的操作
    // }
  },

  methods: {
    setColor(item) {
      if (this.searchVal.indexOf(item) != -1) {
        return "<span style='color:#323232'>" + item + "<span>";
      } else {
        item = item.replaceAll(
          this.searchVal,
          "<a style='color:#45796E'>" + this.searchVal + "<a>"
        );
        return item;
      }
    },
    // 点击搜索
    onSearch() {
      if (this.searchVal == "") {
        return;
      } else {
        let data = {
          hallName: this.searchVal,
        };

        getSearch(data).then((res) => {
          this.oldSearchVal = this.searchVal;
          res.data.result.map((e) => {
            e.value.map((a) => {
              a.name = this.setColor(a.name);
              console.log(a.name);
            });
          });
          this.$forceUpdate();
          this.list = res.data.result;
          this.$router.push({
            path: this.$route.path,
            query: { val: this.searchVal },
          });

          this.totalLength = this.list.reduce(
            (acc, cur) => acc + cur.value.length,
            0
          );
          this.isShow = true;
        });
      }
    },
    toWorship(e) {
      if (e.isStele == 1) {
        this.$router.push({ path: "/stele", query: { id: e.id } });
      } else {
        this.$router.push({ path: "/worship", query: { id: e.id } });
      }
    },

    // 点击清除
    onClose() {
      this.searchVal = "";
      this.list = [];
      this.isShow = false;
    },
  },
};
</script>
<style  lang="scss" scoped>
.venue-topbg {
  width: 100%;
}
.search {
  width: 847px;
  height: 68px;
  margin: 65px auto 36px auto;
  border-radius: 11px;
  border: 1px solid #cb8e3c;
  background: #faf7f4;
  .search-input {
    width: 660px;
    background: #faf7f4;
    border-radius: 11px;
    line-height: 68px;
    padding: 0 27px;
    outline: none;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #323232;
    border: none;
    :focus-visible {
      outline: none;
    }
  }
  .close-tip {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 22px;
    right: 90px;
    cursor: pointer;
  }
  .search-tip {
    width: 24px;
    height: 23px;
    position: absolute;
    top: 22px;
    right: 30px;
    cursor: pointer;
  }
}
.centname {
  font-weight: 600;
  font-size: 22px;
  text-align: left;
  margin-bottom: 15px;
}
.centItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cent-flex {
  display: flex;
  align-items: center;
  .centtext {
    width: 215px;
    white-space: pre;
    text-align: left;
  }
}
.content {
  width: 1200px;
  min-height: 600px;
  margin: 0 auto;
  .data-list {
    cursor: pointer;
    .list-title {
      text-align: left;
      font-size: 20px;
      color: #010101;
      padding: 26px 0 20px 0;
    }
    .val-list {
      display: flex;
      width: 1220px;
      flex-wrap: wrap;
      .main-list {
        // width: 50%;
        height: 160px;
        background: #faf7f4;
        border-radius: 10px;
        margin-right: 20px;
        display: flex;
        width: 590px;
        margin-bottom: 20px;
        .img {
          width: 120px;
          height: 120px;
          border-radius: 10px;
          margin: 20px 28px 20px 20px;
          object-fit: cover;
        }
        .cent-ct {
          text-align: left;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .time {
            color: #8a8a8a;
            font-size: 16px;
            padding-bottom: 11px;
            .day {
              color: #323232;
              font-size: 16px;
              text-align: left;
            }
          }
          .message {
            color: #8a8a8a;
            font-size: 16px;
          }
        }
        .rig-ct {
          margin-left: 42px;
        }
      }
    }
  }
  .empty {
    margin-top: 81px;
    text-align: center;
    img {
      margin-bottom: 15px;
    }
    span {
      display: block;
      margin-bottom: 200px;
      color: #8a8a8a;
      font-size: 20px;
    }
  }
}
.isActive {
  height: 500px;
}
.isActive2 {
  height: 490px;
}
</style>
